/*!
=========================================================
* Painel Toca da Onça — Relatórios
=========================================================
*/
import React from "react";
import { Card, CardBody, CardTitle, Row, Col, Button } from "reactstrap";

const relatorios = [
  { i: "icon-money-coins", t: "Caixa do dia", d: "Total vendido e ticket médio", to: "/admin/notifications" },
  { i: "icon-badge", t: "Comissão por vendedor", d: "Quanto cada um vendeu", to: "/admin/user-profile" },
  { i: "icon-square-pin", t: "Clientes por região", d: "Onde vender mais", to: "/admin/regioes" },
  { i: "icon-chart-bar-32", t: "Preço de mercado", d: "Comparar com concorrentes", to: "/admin/analise-mercado" },
];

function Typography() {
  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>Relatórios</h3>
          <p className="text-muted">Os números do seu negócio, num lugar só.</p>
        </Col>
      </Row>
      <Row>
        {relatorios.map((r, i) => (
          <Col lg="3" md="6" key={i}>
            <Card>
              <CardBody className="text-center">
                <i className={"tim-icons " + r.i + " text-info"} style={{ fontSize: 30 }} />
                <CardTitle tag="h4" className="text-white" style={{ marginTop: 10 }}>{r.t}</CardTitle>
                <p className="text-muted" style={{ minHeight: 40, fontSize: 13 }}>{r.d}</p>
                <Button color="info" size="sm" href={r.to} tag="a">Ver</Button>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default Typography;
